<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction" >
      <wt-form-table-list ref="approvalOutboundTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
        <!-- <template slot="wtFormTableListButtonsAfter" slot-scope="scope">
           <wt-auth v-if="scope.row.state === 2" :hasAnyPremission="form.formCode + ':APPROVAL'" class="search-form-btn">
             <el-button size="mini" type="primary" @click="toClickAction(scope.row, 'APPLY')">审批</el-button>
           </wt-auth>
           <wt-auth v-if="scope.row.state === 10" :hasAnyPremission="form.formCode + ':OUT'" class="search-form-btn">
             <el-button size="mini" type="primary" @click="toClickAction(scope.row, 'OUT')">派车</el-button>
           </wt-auth>
        </template> -->
      </wt-form-table-list>
    </wt-form-table>
    <!-- 审批 -->
    <approval-manage-reason-page
      :visible.sync="applyDialogVisible"
      @refreshData="$refs.approvalOutboundTableRef.requestList()"
    ></approval-manage-reason-page>
    <el-dialog
      title="出库信息"
      :visible.sync="outDialog.visible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="30%"
      key="2"
      :modal="false"
      :before-close="handleOutDialogClose">
      <div>
        <el-form v-if="outDialog.visible" :model="outDialog.form" ref="outDialogForm" label-width="120px">
          <el-form-item label="预计到达时间：" prop="arriveTime" :rules="[{ required: true, message: '预计到达时间不能为空'}]">
            <el-date-picker v-model="outDialog.form.arriveTime" :picker-options="{disabledDate : disabledDate}" type="datetime" placeholder="请选择" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          </el-form-item>
          <el-form-item label="输入司机姓名：" prop="carName"
            :rules="[{ required: true, message: '司机姓名不能为空'}]"
          >
            <el-input type="text" v-model.trim="outDialog.form.carName" autocomplete="off" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="司机手机号：" prop="carPhone"
            :rules="[{ min: 11, max: 11, message: '手机号格式不正确', trigger: 'blur' },
              { pattern: $wtValidator.ValidatorPhonePattern, message: '手机号格式不正确', trigger: 'blur' }]"
          >
            <el-input type="text" v-model.trim="outDialog.form.carPhone" autocomplete="off" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="车牌照号：" prop="carCard">
            <el-input type="text" v-model.trim="outDialog.form.carCard" autocomplete="off" placeholder="请输入"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleOutDialogClose">取 消</el-button>
        <el-button size="small" type="primary" @click="submitOutForm('outDialogForm')">通 过</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ApprovalManageOutbound',
  data() {
    return {
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_APPLY_OUTBOUND',
        formComponent: {
          view: { type: 'component', componentName: 'ApprovalManageViewPage', value: 'queryApprovalDetailData' },
          list: {
            type: 'default', value: '/modules/approve/approveList', params: { type: 3 }}
        },
        formInputsData: [{ name: '申请编号', key: 'id', value: '', type: 'text' },
          { name: '站点名称', key: 'siteName', value: '', type: 'text' },
          { name: '社区', key: 'communityName', value: '', type: 'text' },
          { name: '站长姓名', key: 'employeesName', value: '', type: 'text' },
          { name: '状态',
            key: 'state',
            value: '',
            type: 'select',
            data: [
              { label: '全部', value: '' },
              { label: '等待区域负责人审批', value: 1 },
              { label: '等待平台审批', value: 2 },
              { label: '待出库', value: 5 },
              { label: '区域负责人拒绝', value: 8 },
              { label: '平台拒绝', value: 9 },
              { label: '等待派车', value: 10 },
              { label: '已完成', value: 11 }] },
          { name: '申请时间', key: 'updateTimeRange', value: [], type: 'datetime' }],
        formButtonsData: [{ name: '导出Excel',
          key: 'EXPORT',
          action: 'EXCEL',
          hidden: false,
          url: window.wtConst.BASE_API + '/modules/approve/approveListImport',
          fileName: '出库审批',
          permission: 'EXPORT' }],
        formTableData: [
          { name: '申请编号', key: 'id', type: 'text' },
          { name: '站点名称', key: 'siteName', type: 'text' },
          { name: '站点地址', key: 'siteAddress', type: 'text' },
          { name: '社区', key: 'communityName', type: 'text' },
          { name: '申请人', key: 'employeesName', type: 'text' },
          { name: '申请时间', key: 'siteApproveTime', type: 'text', sortable: 'custom' },
          // { name: '区域负责人', key: 'areaManagerName', type: 'text' },
          // { name: '审批时间', key: 'areaManagerApproveTime', type: 'text', sortable: 'custom' },
          // { name: '平台负责人', key: 'systemName', type: 'text' },
          // { name: '审批时间', key: 'systemApproveTime', type: 'text', sortable: 'custom' },
          { name: '回收站人员', key: 'operatorName', type: 'text' },
          { name: '出库时间', key: 'operatorTime', type: 'text', sortable: 'custom' },
          { name: '状态', key: 'stateName', type: 'text' }],
        formTableButtonsData: [{ name: '查看', key: 'VIEW', action: 'VIEW', className: 'primary', hidden: false, permission: 'VIEW' }],
        formResult: { },
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true, buttonWidth: 130 }
      },
      applyDialogVisible: false,
      outDialog: {
        visible: false,
        form: {
          arriveTime: '',
          carName: '',
          carPhone: '',
          carCard: ''
        }
      }
    }
  },
  methods: {
    onButtonAction() {},
    disabledDate(time) {
      return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
    },
    toClickAction(row, type) {
      if (type === 'APPLY') {
        this.$store.dispatch('queryApprovalDetailData', row.id)
        this.applyDialogVisible = true
      }
      if (type === 'OUT') {
        this.outDialog.form = {
          approveId: row.id,
          arriveTime: '',
          carName: '',
          carPhone: '',
          carCard: ''
        }
        this.outDialog.visible = true
      }
    },
    submitOutForm(formName) {
      const that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.outDialog.form.createTime = that.$dateFormat(new Date(), '-', 'year', 'second')
          that.outDialog.form.updateTime = that.outDialog.form.createTime
          that.$api.approval.approveCarAdd(that.outDialog.form).then(res => {
            that.handleOutDialogClose()
            that.$message({ message: '保存成功', type: 'success' })
            that.$refs.approvalOutboundTableRef.requestList()
          })
        } else {
          return false
        }
      })
    },
    handleOutDialogClose() {
      this.outDialog.visible = false
    }
  }
}
</script>

<style>
</style>
